import {
	type CommonFormSchema,
	COMMON_FIELD_NAME,
	COMMON_FREETEXT_FIELDS,
} from '../common/constants';

export const ANONYMOUS_WHERE = {
	INTERNET: 'internet',
	OTHER: 'other',
} as const;

export type AnonymousWhere = typeof ANONYMOUS_WHERE[keyof typeof ANONYMOUS_WHERE];

// CAUTION: If this is changed, the array below must also be updated, since it's used in zod.enum.
export const WHEN = {
	OTHER: 'other',
	PAST_FORTNIGHT: 'pastFortnight',
	TODAY: 'today',
	YESTERDAY: 'yesterday',
} as const;

// NOTE: Used in zod.enum
export const WHEN_WAS_THE_DRUG_TAKEN_VALUES = [
	WHEN.OTHER,
	WHEN.PAST_FORTNIGHT,
	WHEN.TODAY,
	WHEN.YESTERDAY,
] as const;

export type When = typeof WHEN_WAS_THE_DRUG_TAKEN_VALUES[number];

// One of multiple predefined values.
// Can also be union of literals.
export const ANONYMOUS_ENUM_FIELD_NAME = {
	WHEN_WAS_THE_DRUG_TAKEN: 'whenWasTheDrugTaken',
} as const;

export const ANONYMOUS_DYNAMIC_FIELD_NAME = { // values are updated from some api
	WHERE: 'where', // internet, counties, other
} as const;

export const ANONYMOUS_DYNAMIC_FIELDS = [
	ANONYMOUS_DYNAMIC_FIELD_NAME.WHERE,
] as const;
export type AnonymousDynamicFields = typeof ANONYMOUS_DYNAMIC_FIELDS;

export const ANONYMOUS_FREETEXT_FIELD_NAME = {
	WHEN_WAS_THE_DRUG_TAKEN_OTHER: 'whenWasTheDrugTakenOther',
} as const;

export const ANONYMOUS_FREETEXT_FIELDS = [
	...COMMON_FREETEXT_FIELDS,
	ANONYMOUS_FREETEXT_FIELD_NAME.WHEN_WAS_THE_DRUG_TAKEN_OTHER,
] as const;
export type AnonymousFreetextFields = typeof ANONYMOUS_FREETEXT_FIELDS;

export const ANONYMOUS_FIELD_NAME = {
	...COMMON_FIELD_NAME,
	...ANONYMOUS_ENUM_FIELD_NAME,
	...ANONYMOUS_DYNAMIC_FIELD_NAME,
	...ANONYMOUS_FREETEXT_FIELD_NAME,
} as const;

// This should "mostly" match the zodSchema and JSON.schema.
export interface AnonymousFormSchema extends CommonFormSchema {
	[ANONYMOUS_FIELD_NAME.TYPE]: 'anonymous';
	[ANONYMOUS_FIELD_NAME.WHERE]: string;
	[ANONYMOUS_FIELD_NAME.WHEN_WAS_THE_DRUG_TAKEN]: When;
	[ANONYMOUS_FIELD_NAME.WHEN_WAS_THE_DRUG_TAKEN_OTHER]?: string;
}
